import { createModel } from "hox";
import { useState } from "react"
import { ICompanyDetail, ICompanySearch, IMD5ImgField, ICompanyField } from "./companyTypes"
import { companyService } from "./companyService";
import { message } from "antd";
import { TablePaginationConfig } from "antd/lib/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage, ISelectOptions } from "@/types/AppTypes";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { globalPrompt } from "@/components/message";
import { useDictModel } from "../dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
interface IRestaurantType {
    visible: boolean,
    mode: "add" | "edit" | "look"
}
export const useCompanyModel = createModel(function () {
    const { user } = useGlobalModel()
    const {getSelectedDictOne} = useDictModel()

    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //列表数据
    const [dataSource, setDataSource] = useState<ICompanyDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ICompanyField>({});
    //分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const initMd5 = {
        "id": "",
        "imgMd5": "",
        "imgTitle": "",
        "honorId": ""
    }
    const [selectedRow, setSelectedRow] = useState<ICompanyField[]>([]);
    const [md5FormVal, setMd5FormVal] = useState<string[]>([]) //图片md5值
    const [md5List, setMd5List] = useState<IMD5ImgField[]>([]) //图片md5值

    const [categoryOption, setCategoryOption] = useState<ISelectOptions[]>([])


    //抽屉框
    const initShopDrawer: IRestaurantType = { visible: false, mode: "add" }
    const [visibleDrawer, setVisibleDrawer] = useState<IRestaurantType>(initShopDrawer);
    const setIVisibleDrawer = (str?: "add" | "edit" | "look") => setVisibleDrawer(str ? { visible: true, mode: str } : initShopDrawer);


    //设置搜索value
    const updateSearchParam = (updateParam: ICompanyField) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: ICompanyField = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await companyService.page(searchParams);
        const { items, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(items);
    }
    //新增公司荣誉
    const insertDetail = useLockFn(async (params: ICompanyField) => {

        let newMd5List = md5FormVal.map((item) => {
            return {
                imgMd5: item,
                id: "",
                imgTitle: "",
                honorId: ""
            }
        })
        let { retData } = await companyService.insert({ ...params, createUser: user.userName, list: newMd5List });
        if (retData) {
            loadData();
            setIVisibleDrawer();
            setMd5FormVal([]);
            setMd5List([]);
            globalPrompt("message", { text: "公司荣誉新增成功", type: "success" })
        } else {
            globalPrompt("message", { text: "公司荣誉新增失败", type: "success" })
        }
    })
    //编辑公司荣誉
    const editDetail = useLockFn(async (params: ICompanyField) => {
        let newMd5List: IMD5ImgField[] = [];
        // console.log(md5FormVal, md5List)
        md5FormVal.forEach((formItem, formInd, formArr) => {
            md5List.length!== 0 ?md5List.forEach((listItem, listInd, listArr) => {
                if (formInd === listInd) {
                    let { imgMd5, ...item } = listItem
                    newMd5List.push({ ...item, imgMd5: formItem })
                } else if (formArr.length > listArr.length) {
                    newMd5List.push({ ...initMd5, imgMd5: formItem })
                }
            }):newMd5List.push({ ...initMd5, imgMd5: formItem })
        })
        let { retData } = await companyService.update({ ...params, id: selectedRow[0].id, updateUser: user.userName, list: newMd5List })
        if (retData) {
            loadData();
            setIVisibleDrawer();
            setMd5FormVal([]);
            setMd5List([]);
            globalPrompt("message", { text: "公司荣誉编辑成功", type: "success" })
        } else {
            globalPrompt("message", { text: "公司荣誉编辑失败", type: "success" })
        }
    })
    const onRemove = useLockFn(async (id: string[]) => {
        let { retData } = await companyService.delete({id})
        if (retData) {
            loadData();
            globalPrompt("message", { text: "公司荣誉删除成功", type: "success" });
            setSelectedRowKeys([]);
        }
    })

    const initCategory = async () => {
        const options = await getSelectedDictOne(DictCodeEnmu.BUS)
        setCategoryOption(options)
    }
    return {
        dataSource,
        searchParam,
        pgCfg,
        selectedRowKeys,
        initPgCfg,
        selectedRow,
        visibleDrawer,
        md5FormVal,
        setSelectedRowKeys,
        setPgCfg,
        setSearchParam,
        setDataSource,
        updateSearchParam,
        resetSearchParam,
        loadData,
        setSelectedRow,
        setVisibleDrawer,
        setIVisibleDrawer,
        insertDetail,
        editDetail,
        onRemove,
        setMd5FormVal,
        md5List,
        setMd5List,
        initCategory,
        categoryOption
    }
})